// extracted by mini-css-extract-plugin
export default {"commentList":"_55SIe","separator":"dhkI-"};